import { GridLegendItem } from '../legend';

interface OsrDataItem {
    isCancelled: boolean;
    isQuestion?: boolean;
    hasResultDataRevision?: boolean;
    hasSubjectDataRevision?: boolean;
    hasVisitDataRevision?: boolean;
    hasSpecimenResultDataRevision?: boolean;
    hasOrganismResultDataRevision?: boolean;
    hasGrowthResultDataRevision?: boolean;
    hasTestResultDataRevision?: boolean;
}

export function createLegend(data: OsrDataItem[]): GridLegendItem[] {

    if (!data) {
        return [];
    }
    const legendData: GridLegendItem[] = [];

    const anyCancelations = data.some(r => r.isCancelled);
    if (anyCancelations) {
        legendData.push({ icon: 'clear', cssClass: 'cancelled-result', label: 'Canceled result' });
    }
    const anyRevisions = data.some(r => r.hasResultDataRevision
        || r.hasSubjectDataRevision
        || r.hasVisitDataRevision
        || r.hasSpecimenResultDataRevision
        || r.hasOrganismResultDataRevision
        || r.hasGrowthResultDataRevision
        || r.hasTestResultDataRevision);
    if (anyRevisions) {
        legendData.push({
            text: 'Δ', cssClass: 'revisioned-result', label: 'Data change occurred'
        });
    }
    const anyAdminQuestions = data.some(r => r.isQuestion);
    if (anyAdminQuestions) {
        legendData.push({ icon: 'question_answer', cssClass: 'grid-icon', label: 'Administrative Question' });
    }

    return legendData;
}